<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="card card-body p-5" v-if="isLoadingData">
      <LoadingData text="Aguarde enquando os dados estão sendo carregados..." />
    </div>
    <div class="card card-body" v-else-if="hasError">
      <div class="d-flex flex-column align-items-center">
        <h3 class="text-danger">Atenção!</h3>
        <p>{{ messageError }}</p>
      </div>
    </div>
    <div class="card card-body" v-else>
      <HeaderSurveyUser />
      <StructureSurveyUser
        :survey="survey"
        :questions="questions"
        @reloadSurvey="reloadSurvey"
      />
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import HeaderSurveyUser from '@/components/surveyUser/HeaderSurveyUser.vue'
import StructureSurveyUser from '@/components/surveyUser/StructureSurveyUser.vue'

export default {
  name: 'SurveyUser',

  components: {
    LoadingData,
    HeaderSurveyUser,
    StructureSurveyUser,
  },

  data() {
    return {
      uuid: this.$route.params.uuid,
      survey: null,
      questions: [],
      isLoadingData: true,
      hasError: false,
      messageError: '',
      disableButton: false,
    }
  },

  methods: {
    async getSurvey() {
      try {
        this.survey = await this.$store.dispatch('getSurveyByUuid', this.uuid)

        if (Number(this.survey.status) === 0) {
          await this.setSurveyAsRead()
        }

        this.isLoadingData = false
      } catch (error) {
        this.isLoadingData = false
        if (error && error.message) {
          this.hasError = true
          this.messageError = error.message
        } else {
          this.hasError = true
          this.messageError = 'Não foi possível se conectar ao servidor.'
        }
      }
    },

    async getSurveyQuestions() {
      try {
        this.questions = await this.$store.dispatch(
          'getSurveyQuestionsByUuid',
          this.uuid,
        )
      } catch (error) {
        this.isLoadingData = false
        if (error && error.message) {
          this.hasError = true
          this.messageError = error.message
        } else {
          this.hasError = true
          this.messageError = 'Não foi possível se conectar ao servidor.'
        }
      }
    },

    async setSurveyAsRead() {
      try {
        await this.$store.dispatch('setSurveyAsRead', this.uuid)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    reloadSurvey() {
      this.getSurvey()
    },
  },

  mounted() {
    this.getSurvey()
    this.getSurveyQuestions()
  },
}
</script>
